import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-setting" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "title-setting" }, "Parâmetros de Expedição", -1)
const _hoisted_3 = { class: "container-setting-table" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h1", null, "Gerenciar parâmetros de expedição"),
    /*#__PURE__*/_createElementVNode("h3", null, " Aqui você pode definir os parâmetros de busca e configuração da tabela para cada rua. ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsModal = _resolveComponent("SettingsModal")!
  const _component_TableSetting = _resolveComponent("TableSetting")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_SettingsModal, {
        class: "modal-settings",
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal())),
        show: _ctx.showModal,
        user: _ctx.selectedUser,
        tabs: _ctx.tabs
      }, null, 8, ["show", "user", "tabs"]),
      _createVNode(_component_TableSetting, {
        class: "mt-4",
        prop_table_data: _ctx.getExpeditionUsersList,
        columns: [
          { name: 'PAR_ENDERECO', header: 'Endereço' },
          { name: 'PAR_ATIVO', header: 'Situação', type: 'switch' },
        ],
        onSaveAlert: _ctx.timeAlert,
        onOpenUser: _ctx.toggleModal,
        showHeaders: true,
        onToggleAddressStatus: _ctx.handleToggleAddressStatus,
        tablestyle: "main-table",
        tabletype: "user"
      }, null, 8, ["prop_table_data", "onSaveAlert", "onOpenUser", "onToggleAddressStatus"])
    ])
  ]))
}